module.exports = __webpack_public_path__ + "img/16.29cf61d1.png";